// extracted by mini-css-extract-plugin
export default {"useNextVariants":"true","fontFamily":"\"Gotham SSm A\",\"Gotham SSm B\",Verdana,Geneva,Tahoma,sans-serif","fontWeightRegular":"300"};